import { Link } from "react-router-dom";

import { buttonClass } from "@/components/buttonStyles";
// What a page or list shows while PMS doesn't serve its data yet (BRK-S251,
// BRK-S201): it says so, and where that data lives today, with exactly one real
// link there. No count, no date and no inert control: a promise nobody
// committed to is the same fake as a placeholder row. BRK-S198 re-homes it in
// src/ui with the same props.
export interface NotYetAvailableProps {
  title: string;
  body: string;
  href: string;
  linkLabel: string;
}

export function NotYetAvailable({
  title,
  body,
  href,
  linkLabel,
  framed = true,
}: NotYetAvailableProps & {
  /** Its own dashed card on a page, or bare inside a list's frame. */
  framed?: boolean;
}) {
  return (
    <div
      className={`flex flex-col items-center gap-2 px-6 py-10 text-center ${
        framed
          ? "rounded-xl border border-dashed border-brk-border bg-brk-panel"
          : ""
      }`}
    >
      <h2 className="text-heading text-brk-text">{title}</h2>
      <p className="max-w-prose text-sm text-brk-dim">{body}</p>
      <Link
        to={href}
        className={`${buttonClass({ variant: "secondary" })} mt-2`}
      >
        {linkLabel}
      </Link>
    </div>
  );
}
